module.exports = __webpack_public_path__ + "img/receipt18.8ff17f5f.png";